<!--suppress XmlInvalidId, HtmlUnknownBooleanAttribute, AngularUndefinedBinding -->
<form [formGroup]="productForm" class="w-100" novalidate action="javascript:void(0);">
  <div class="form-row">
    <div class="col-md-12 mb-2 form-group">
      <div class="custom-file-container" data-upload-id="productImage">
        <div class="custom-file-container__image-preview d-flex" style="height: 300px">
          <img alt="product image" class="mx-auto" style="max-height: 300px;max-width: 300px" *ngIf="imageUrl != null" [src]="imageUrl"/>
          <img alt="product no-image" class="mx-auto" style="max-height: 300px;max-width: 300px" *ngIf="imageUrl == null" src="./assets/img/no-image.png" width="300"/>
        </div>
      </div>
    </div>
  </div>
  <div class="form-row">
    <select size="1" formControlName="title" (change)="selectProduct($event.target.value)" class="form-control" name="row-1-office">
      <option selected="selected">
        {{'Select a product' | translate}}
      </option>
      <option *ngFor="let p of products" [attr.value]="p.id">
        {{p.title}} {{p.price}} ({{'SAR' | translate}})
      </option>
    </select>
  </div>
  <div class="form-row">
    <div class="col-md-12 mb-4 form-group">
      <label for="description" translate>Description</label>
      <textarea formControlName="description" class="form-control" id="description" rows="3"></textarea>
    </div>
  </div>
  <div class="form-row">
    <div class="col-md-6 mb-4">
      <label for="price" translate>Price</label>
      <input [ngClass]="{'is-invalid' : submitted && f.price.errors}" type="text" formControlName="price" class="form-control" id="price" placeholder="{{'Price' | translate}}">
      <div *ngIf="submitted && f.price.errors && f.price.errors.required" class="invalid-feedback" translate>
        Required field
      </div>
      <div *ngIf="submitted && f.price.errors && f.price.errors.pattern" class="invalid-feedback" translate>
        Invalid value
      </div>
    </div>
    <div class="col-md-6 mb-4">
      <label for="qty">{{'Qty' | translate}} <span *ngIf="this.selectedProduct">({{'Stock' | translate}} {{this.selectedProduct.stockQty}})</span> </label>
      <input [ngClass]="{'is-invalid' : submitted && f.qty.errors}" formControlName="qty" type="text" class="form-control" id="qty" placeholder="{{'Qty' | translate}}">
      <div *ngIf="submitted && f.qty.errors && f.qty.errors.required" class="invalid-feedback" translate>
        Required field
      </div>
      <div *ngIf="submitted && f.qty.errors && f.qty.errors.pattern" class="invalid-feedback" translate>
        Invalid value
      </div>
    </div>
  </div>
  <button class="btn btn-primary" data-dismiss="modal" aria-label="Close" type="button" *ngIf="isMerchant || isManager || isSales" (click)="submitForm()" translate>OK</button>&nbsp;
  <button class="btn btn-light-danger" data-dismiss="modal" aria-label="Close" type="button" (click)="closeModal()" translate>Close</button>

</form>
